import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LongPressService {
  isLongPress = false; // Boolean to track if the long press occurred

  constructor() {}

  // Method to set the long press state
  setLongPressState(state: boolean): void {
    this.isLongPress = state;
  }

  // Method to get the current long press state
  getLongPressState(): boolean {
    return this.isLongPress;
  }
}
